import { render, staticRenderFns } from "./PersonalDataComponent.vue?vue&type=template&id=8baba670&scoped=true&"
import script from "./PersonalDataComponent.vue?vue&type=script&lang=ts&"
export * from "./PersonalDataComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baba670",
  null
  
)

export default component.exports